import React from "react";
import styles from "./ui.module.scss";
import EventScheduleCard from "./EventScheduleCard";
import EventDescription from "./EventDescription";
import EventRequirements from "./EventRequirements";
import { useEventStore } from "../../store";
import Link from "next/link";
import { EventMobileJoinedUsers } from "./EventJoinedUsers";

const EventSchedule = () => {
  const { eventData } = useEventStore();

  return (
    <>
      <EventScheduleCard />
      <EventMobileJoinedUsers />
      <EventDescription />
      <EventRequirements />
      {eventData?.donors_requirements?.length === 0 && (
        <div className={styles.EventRequirements_MedContainer}>
          <Link href={"/requirements/"}>
            <a target={"_blank"} className={styles.EventRequirements_MedLink}>
              <span>Медицинские противопоказания</span>
            </a>
          </Link>
        </div>
      )}
    </>
  );
};

export default EventSchedule;
